const isFiniteNumber = (value) => Number.isFinite(Number(value));
// Zero is a valid displayed market price (for example, an illiquid option can show
// 0.00 x 0.05). Null/undefined must still be rejected because Number(null) is 0.
const isNonNegativeFinite = (value) => {
  const n = Number(value);
  return value !== null && value !== undefined && Number.isFinite(n) && n >= 0;
};

/**
 * Computes unrealized PnL from a live bid/ask quote.
 *
 * The `symbol` passed to PnLDisplay must be the actual traded instrument
 * (positionSymbol for options, not the underlying). If the quote is for the
 * underlying stock instead of the option, the price will be wrong by orders
 * of magnitude. When no quote is found for the position symbol, this returns
 * null and the caller falls back to metrics.unrealizedPnl from the backend.
 */
export const liveQuoteUnrealizedPnl = ({ metrics, quote }) => {
  if (!metrics || !quote || !isFiniteNumber(metrics.fillPrice) || !isFiniteNumber(metrics.openQuantity)) {
    return null;
  }

  const position = metrics.position ?? {};
  const side = `${position.side ?? position.quantityDirection ?? ''}`.toLowerCase();
  const isLong = position.sideLong === false
    ? false
    : side.includes('short') || side.includes('sell')
      ? false
      : true;
  const price = isLong
    ? isNonNegativeFinite(quote.bid) ? Number(quote.bid) : null
    : isNonNegativeFinite(quote.ask) ? Number(quote.ask) : null;

  if (price == null) return null;
  return (isLong ? price - Number(metrics.fillPrice) : Number(metrics.fillPrice) - price) *
    Number(metrics.openQuantity) *
    Number(metrics.priceMultiplier ?? 1);
};
